// extracted by mini-css-extract-plugin
module.exports = {"video":"style_video__EIOEY","collect_buttons_container":"style_collect_buttons_container__3z6e2"};